import React, { ReactElement } from "react";
import { FaLeaf, FaHandshake, FaRecycle } from "react-icons/fa";
import { companyConfig } from "../config/company";
import "./About.css";

interface CompanyValue {
  icon: ReactElement;
  title: string;
  description: string;
}

const About: React.FC = () => {
  const values: CompanyValue[] = [
    {
      icon: <FaLeaf />,
      title: "Nachhaltigkeit",
      description:
        "Wir arbeiten umweltbewusst und nachhaltig, um die Natur zu schützen und zu bewahren.",
    },
    {
      icon: <FaHandshake />,
      title: "Zuverlässigkeit",
      description:
        "Auf uns können Sie sich verlassen. Wir halten, was wir versprechen.",
    },
    {
      icon: <FaRecycle />,
      title: "Qualität",
      description:
        "Hochwertige Materialien und fachgerechte Ausführung sind für uns selbstverständlich.",
    },
  ];

  return (
    <section className="about">
      <div className="about-container">
        <h2>Über {companyConfig.name}</h2>

        <div className="about-content">
          <div className="company-story">
            <h3>Unsere Geschichte</h3>
            <p>
              Seit über 15 Jahren gestalten und pflegen wir Gärten und
              Außenanlagen in {companyConfig.location.region}. Was als kleiner
              Familienbetrieb begann, hat sich zu einem verlässlichen Partner
              für private und gewerbliche Kunden entwickelt.
            </p>
            <p>
              Unser Team besteht aus qualifizierten Fachkräften, die ihre Arbeit
              mit Leidenschaft und Präzision ausführen. Wir legen großen Wert
              auf kontinuierliche Weiterbildung, um Ihnen stets die beste
              Qualität und modernsten Techniken bieten zu können.
            </p>
          </div>

          <div className="company-values">
            <h3>Unsere Werte</h3>
            <div className="values-grid">
              {values.map((value, index) => (
                <div key={index} className="value-card">
                  <div className="value-icon">{value.icon}</div>
                  <h4>{value.title}</h4>
                  <p>{value.description}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="team-section">
            <h3>Unser Team</h3>
            <div className="team-description">
              <p>
                Unter der Leitung von {companyConfig.owner} besteht unser
                erfahrenes Team aus:
              </p>
              <ul>
                <li>Garten- und Landschaftsbauern</li>
                <li>Gärtnern</li>
                <li>Fachkundigen Hausmeistern</li>
                <li>Kompetenten Servicemitarbeitern</li>
              </ul>
              <p>
                Gemeinsam arbeiten wir daran, Ihre Wünsche und Vorstellungen
                professionell umzusetzen und Ihnen ein optimales Ergebnis zu
                liefern.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
